import React from 'react';
import { useDispatch } from 'react-redux';
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  IconButton,
  Button,
  Tooltip,
} from '@mui/material';

import {
  DeleteIcon,
  EditPencilIcon,
  LineUpIcon,
} from '../../../Icons/DashboardIcons';

import fallbackImg from '../../../utilities/dummy_assets/login.jpg';
import { ImageBaseURL } from '../../../utilities/api/axios';
import {
  setTutEditMode,
  setTutCurrentItem,
} from '../../../redux/slices/tutorialEditSlice';

const ListTutorialCard = ({ item }) => {
  const dispatch = useDispatch();

  return (
    <Card
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        padding: '18px',
        borderRadius: '18px',
        border: '1px solid #E5E7EB',
        backgroundColor: '#FFFFFF',
        boxShadow: '0px 2px 6px rgba(0,0,0,0.05)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Left Image */}
      <CardMedia
        component="img"
        image={item.image ? (item.image.startsWith('http') ? item.image : `${ImageBaseURL}${item.image}`) : fallbackImg}
        onError={(e) => (e.currentTarget.src = fallbackImg)}
        sx={{
          width: '120px',
          height: '120px',
          borderRadius: '12px',
          objectFit: 'cover',
          marginBottom: { xs: '16px', sm: '0' },
          marginRight: { xs: '0', sm: '22px' },
          flexShrink: 0,
        }}
      />

      {/* Text Area */}
      <Box
        sx={{
          textAlign: 'left',
        }}
      >
        {/* Title */}
        <Typography
          sx={{
            fontSize: '22px',
            fontWeight: 600,
            color: '#111827',
            marginBottom: '10px',
            wordBreak: 'break-word',
            maxWidth: '100%',
          }}
        >
          {item.name}
        </Typography>

        {/* Description */}
        <Tooltip title={item.description || item.topic || '-'}>
          <Typography
            sx={{
              fontSize: '15px',
              color: '#4B5563',
              lineHeight: 1.4,
              marginBottom: '10px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              maxWidth: {xs: '200px', sm: '400px', md: '600px', lg: '800px' },
            }}
          >
            Description: {item.description || item.topic || '-'}
          </Typography>
        </Tooltip>

        {/* Mentor */}
        <Typography sx={{ fontSize: '14px', color: '#6B7280' }}>
          Mentor: {item.mentor || '-'}
        </Typography>
      </Box>

      {/* Edit Button (Top Right) */}
      <Button
        onClick={() => {
          dispatch(setTutEditMode(true));
          dispatch(setTutCurrentItem(item));
        }}
        sx={{
          position: 'absolute',
          top: '16px',
          right: '16px',
          height: '40px',
          width: '40px',
          minWidth: '40px',
          borderRadius: '50%',
          border: '1px solid #007BFF',
          color: '#007BFF',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'transparent',
          '&:hover': { backgroundColor: '#EAF2FF' },
        }}
      >
        <EditPencilIcon />
      </Button>

      {/* Stats + Delete Buttons (Bottom Right) */}
      <Box
        sx={{
          position: 'absolute',
          bottom: '14px',
          right: '16px',
          display: 'flex',
          gap: '10px',
        }}
      >
        <IconButton
          sx={{
            background: '#FFFFFF',
            border: '1px solid #E5E7EB',
            borderRadius: '12px',
            padding: '8px',
            '&:hover': { background: '#F3F4F6' },
          }}
          onClick={() => {
            dispatch(setTutEditMode(true));
            dispatch(setTutCurrentItem(item));
          }}
        >
          <LineUpIcon />
        </IconButton>
        <IconButton
          sx={{
            background: '#FFFFFF',
            border: '1px solid #E5E7EB',
            borderRadius: '12px',
            padding: '8px',
            '&:hover': { background: '#FEE2E2' },
          }}
        >
          <DeleteIcon />
        </IconButton>
      </Box>
    </Card>
  );
};

export default ListTutorialCard;
